import { otherRouter, router } from '../../router'
import store from '../../store'
import { Message } from 'element-ui'
import { getUrlParam } from '@/assets/js/utils'

function checkRoot (to) {
  // 权限列表中有该页面
  const keyList = to.path.split('/')
  const name = to.name || keyList[keyList.length - 1]
  // 是否在无需控制权限列表中，不需要根据root对象判断，即不需要登陆
  const inOtherRouter = otherRouter.some(item => {
    return item.name === name ||
      (item.children && item.children[0].name === name)
  })
  if (inOtherRouter) return true
  // 如果缓存中没有用户信息，请求查看信息接口获取
  if (!localStorage.getItem('userInfo') || !localStorage.getItem('navBar')) {
    // 若没有登陆，请求该接口会被拦截
    store.dispatch('getUserInfo').then(() => {
      return store.state.root[name]
    })
  }
  if (JSON.stringify(store.state.navBar) === '{}' && localStorage.getItem('navBar')) {
    store.commit('updateNavBar', JSON.parse(localStorage.getItem('navBar')))
    store.commit('updateRoot')
  }
  if (JSON.stringify(store.state.root) === '{}') {
    store.commit('updateRoot')
  }
  // 是否在不展示在侧边栏页面列表中
  // const inSingleRouter = singleRouter.filter(item => {
  //   return item.name === name ||
  //     (item.children && item.children[0].name === name)
  // })
  // // 页面不在侧边栏展示但是需要权限控制
  // if (inSingleRouter.length > 0 && inSingleRouter[0].children[0].meta.root) {
  //   return inSingleRouter[0].children[0].meta.root.some(item => {
  //     return store.state.root[item]
  //   })
  // } else if (JSON.stringify(store.state.navBar) !== '{}') {
  if (JSON.stringify(store.state.navBar) !== '{}') {
    if (store.state.root[name] && store.state.root[name].length > 0) {
      to.meta.handler = store.state.root[name]
    }
    return store.state.root[name]
  } else {
    return false
  }
}

// 路由相关
router.beforeEach((to, from, next) => {
  if (to.name === 'index') {
    const sessionId = getUrlParam().LS_SAAS_CMS_SESSIONID || localStorage.getItem('LS_SAAS_CMS_SESSIONID')
    const userName = getUrlParam().userName || localStorage.getItem('LS-SAAS-CMS-UIN')
    localStorage.setItem('LS_SAAS_CMS_SESSIONID', sessionId)
    localStorage.setItem('LS-SAAS-CMS-UIN', userName)
  }
  if (from.name === to.name) {
    next(false)
    return
  }
  if (to.name === 'login') {
    next()
    return
  }
  // 如果缓存中有用户信息，但是store中没有，存储至store
  if (store.state.userInfo.userName === undefined && localStorage.getItem('userInfo')) {
    store.commit('updateUserInfo', JSON.parse(localStorage.getItem('userInfo')))
  }
  if (checkRoot(to) || to.name === 'index') {
    next()
  } else {
    Message({
      type: 'warning',
      message: '您没有该页面权限！'
    })
    if (JSON.stringify(store.state.root) === '{}') {
      next({ path: '/login' })
    } else {
      next({ path: '/' })
    }
  }
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
